import * as Models from '../';

export interface ISystemComponent {
  systemComponentId: number;
  quantity: number;
  component: Component;
  arrayDataDetails: Models.SystemDetails.ArrayData.ArrayData[];
  displayName: string;
}

export class SystemComponent implements ISystemComponent {
  systemComponentId: number;
  quantity: number;
  component: Component;
  arrayDataDetails: Models.SystemDetails.ArrayData.ArrayData[];
  displayName: string;

  constructor(
    systemComponentId: number,
    quantity: number,
    componentId: number,
    name: string,
    type: string,
    manufacturer: string,
    model: string,
    arrayDataDetails: Models.SystemDetails.ArrayData.ArrayData[] = [],
  ) {
    this.systemComponentId = systemComponentId;
    this.quantity = quantity;
    this.arrayDataDetails = arrayDataDetails;
    this.component = new Component(componentId, name, type, manufacturer, model);
  }
}

export interface IComponent {
  componentId: number;
  name: string;
  type: string;
  panelWattage: number;
  inverterCapacity: number;
  manufacturer: string;
  model: string;
  codeIsEditable: boolean;
  canBeDeleted: boolean;
  isBeingEdited: boolean;
  active: boolean;
  moduleType: Models.SystemDetails.ModuleTypeModel.ModuleTypeModel;
  nameplateRatingLossPercentage: number;
  efficiency: number;
  mountingType: Models.SystemDetails.MountingTypeModel.MountingTypeModel;
  mountingTypeId: number;
}

export class Component implements IComponent {
  componentId: number;
  name: string;
  type: string;
  panelWattage: number;
  inverterCapacity: number;
  manufacturer: string;
  model: string;
  codeIsEditable: boolean;
  canBeDeleted: boolean;
  isBeingEdited: boolean;
  active: boolean;
  moduleType: Models.SystemDetails.ModuleTypeModel.ModuleTypeModel;
  nameplateRatingLossPercentage: number;
  efficiency: number;
  mountingType: Models.SystemDetails.MountingTypeModel.MountingTypeModel;
  mountingTypeId: number;

  constructor(componentId?: number, name?: string, type?: string, manufacturer?: string, model?: string) {
    this.componentId = componentId;
    this.name = name;
    this.type = type;
    this.manufacturer = manufacturer;
    this.model = model;
    this.codeIsEditable = true;
    this.canBeDeleted = true;
    this.isBeingEdited = false;
    this.active = true;
  }
}
